import BemIt, { addClass } from "@gtechdoodler/bem-it";

import StyledSemanticBadge from "./SemanticBadge.styles";
import { SemanticBadgeProps } from "./SemanticBadge.types";

const SemanticBadge: React.FC<SemanticBadgeProps> = ({
	className,
	iconPosition = "right",
	size = "lg",
	variant = "success",
	...props
}) => {
	const block = new BemIt("SemanticBadge");

	return (
		<StyledSemanticBadge
			className={addClass(className).after(block.mod(size))}
			size={size}
			iconPosition={iconPosition}
			variant={variant}
			{...props}
		/>
	);
};

export default SemanticBadge;
